var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gotob",on:{"click":function($event){return _vm.goOff()}}},[_vm._v("返回")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// D:/ADO_CICD/tools/nodejs/portal/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ead4b8e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!D:/ADO_CICD/tools/nodejs/portal/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/layout-goback.vue
// module id = null
// module chunks = 